import { httpRequest } from "../../http";
import { RunVersionPreview } from "@models/configVersion.model";

export class CommandPreviewRunVersions {
  async run(runId: number): Promise<RunVersionPreview> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/ingest/files/${runId}/preview-versions/`;
    return httpRequest<RunVersionPreview>(url, { method: "GET" });
  }
}
